export default "__VITE_ASSET__DFzUjDzT__"